import BoxContainerV2 from './BoxContainerV2';

export default BoxContainerV2;
